var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2475_6590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1399 10.5933C13.7158 11.5963 13.0525 12.4802 12.2079 13.1675C11.3633 13.8549 10.3631 14.325 9.2949 14.5365C8.22668 14.7481 7.12289 14.6948 6.08004 14.3812C5.03719 14.0676 4.08703 13.5034 3.31262 12.7378C2.53822 11.9722 1.96315 11.0285 1.6377 9.98931C1.31225 8.9501 1.24632 7.847 1.44568 6.77643C1.64503 5.70586 2.10361 4.70042 2.78131 3.84803C3.45901 2.99563 4.3352 2.32222 5.33328 1.88667",
    stroke: "#EAECF0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 7.99999C14.6667 7.12452 14.4942 6.25761 14.1592 5.44877C13.8242 4.63993 13.3331 3.90501 12.714 3.28595C12.095 2.66689 11.3601 2.17583 10.5512 1.8408C9.74239 1.50577 8.87548 1.33333 8 1.33333V7.99999H14.6667Z",
    stroke: "#EAECF0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2475_6590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports2);
export default __webpack_public_path__ + "static/media/reports2.542e16ef59548f49c65e222f95fe8a72.svg";
export { ForwardRef as ReactComponent };